export type VideoLanguage = 'fr' | 'en';

export type BilingualVideoValue = {
  video?: string | null;
  videoEn?: string | null;
  autoPlayVideo?: number | null;
  muteVideo?: number | null;
  autoPlayVideoEn?: number | null;
  muteVideoEn?: number | null;
};

export const videoVersion = (value: BilingualVideoValue, language: VideoLanguage) =>
  language === 'en'
    ? {
        video: value.videoEn || '',
        autoPlayVideo: value.autoPlayVideoEn || 0,
        muteVideo: value.muteVideoEn || 0,
      }
    : {
        video: value.video || '',
        autoPlayVideo: value.autoPlayVideo || 0,
        muteVideo: value.muteVideo || 0,
      };

export const setVideoVersion = (
  value: BilingualVideoValue,
  language: VideoLanguage,
  version: ReturnType<typeof videoVersion>
): BilingualVideoValue =>
  language === 'en'
    ? {
        ...value,
        videoEn: version.video,
        autoPlayVideoEn: version.autoPlayVideo,
        muteVideoEn: version.muteVideo,
      }
    : { ...value, ...version };

export const videoLanguages = (value: BilingualVideoValue): VideoLanguage[] =>
  !value.video && value.videoEn ? ['en', 'fr'] : ['fr', 'en'];

export const localizedVideo = (value: BilingualVideoValue, language: string) => {
  const preferred = language === 'GB' || language.toLowerCase().startsWith('en') ? 'en' : 'fr';
  const version = videoVersion(value, preferred);
  return version.video ? version : videoVersion(value, preferred === 'en' ? 'fr' : 'en');
};

export const emptyVideo: BilingualVideoValue = {
  video: '',
  videoEn: '',
  autoPlayVideo: 0,
  muteVideo: 0,
  autoPlayVideoEn: 0,
  muteVideoEn: 0,
};
